// removed by extract-text-webpack-plugin
module.exports = {"contentPanel":"_2BDo9JEHRJrvq4IQ1gNcsZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Family/LandingPage/LandingPage.css
// module id = 1295
// module chunks = 0